import React from 'react'
import { Button, Dropdown, Menu, Icon, Spin, Tooltip } from 'antd'
import { ImagePreview } from '../../../../../components'
import CommentInput from '../../CommentInput'
import ImageHistoryModal from './ImageHistoryModal'
import EntitySelectorList from '../../EntitySelectorList'
const ShotCard = ({
  DragHandle,
  shot,
  shotIndex,
  sceneId,
  formData,
  setFormData,
  handleDeleteShot,
  handleRegenerateImage,
  handleRegenerateWithReference,
  handleRegenerateWithReferenceNanoBanana,
  handleEditSettings,
  updateShotDataRef
}) => {
  const [historyModalVisible, setHistoryModalVisible] = React.useState(false)

  return (
    <div className="shot-card">
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}
      >
        <h3
          className="shot-title"
          style={{ margin: 0, display: 'flex', alignItems: 'center' }}
        >
          {DragHandle && <DragHandle />}
          Shot {shotIndex}
        </h3>
        <Dropdown
          overlay={
            <Menu>
              <Menu.Item
                key="delete-shot"
                onClick={() => handleDeleteShot(sceneId, shot.id)}
              >
                <Icon type="delete" /> Delete Shot
              </Menu.Item>
            </Menu>
          }
          trigger={['click']}
          placement="bottomRight"
        >
          <Button type="link" size="small">
            Action <Icon type="down" />
          </Button>
        </Dropdown>
      </div>

      <div
        className="image-wrapper"
        style={
          shot.error
            ? { border: '1px solid #ff4d4f', position: 'relative' }
            : { position: 'relative' }
        }
      >
        {shot.isGenerating && shot.progress !== 100 && (
          <div className="progress-overlay">
            <Spin style={{ color: '#fff' }} size="large" />
            <span className="progress-text">
              {shot.progress ? 'Generated Successfully' : 'Generating...'}
            </span>
          </div>
        )}
        {!shot.isGenerating && shot.error && (
          <div
            style={{
              position: 'absolute',
              top: 8,
              right: 8,
              background: '#fff',
              border: '1px solid #ff4d4f',
              color: '#ff4d4f',
              borderRadius: 4,
              padding: '2px 6px',
              fontSize: 12,
              fontWeight: 600
            }}
          >
            Task failed. Please regenerate.
          </div>
        )}
        {shot.imageSrc && (
          <ImagePreview
            src={shot.imageSrc || '/api/placeholder/400/300'}
            alt={`Shot ${shot.id}`}
            style={{ width: '100%', height: '100%', objectFit: 'contain' }}
          />
        )}

        {/* History Button - Absolutely Positioned */}
        {shot.images_history && shot.images_history.length > 0 && (
          <div style={{ position: 'absolute', top: 12, left: 12, zIndex: 10 }}>
            <Tooltip title={`View History (${shot.images_history.length})`}>
              <Button
                shape="round"
                onClick={() => setHistoryModalVisible(true)}
                disabled={shot.isGenerating}
                style={{
                  backgroundColor: 'rgba(0, 0, 0, 0.65)',
                  color: '#fff',
                  border: '1px solid rgba(255, 255, 255, 0.2)',
                  backdropFilter: 'blur(4px)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
                }}
              >
                <Icon type="history" />
              </Button>
            </Tooltip>
          </div>
        )}
      </div>

      <EntitySelectorList
        activePrompt={shot.initial_image_prompt}
        onUpdatePrompt={newText =>
          updateShotDataRef.current(shot.id, 'initial_image_prompt', newText)
        }
        formData={{ ...formData, setFormData }}
        disabled={shot.isGenerating}
      />

      <CommentInput
        disabled={shot.isGenerating}
        text={shot.initial_image_prompt}
        placeholder="Write your image prompt..."
        characterList={formData.characterList}
        locationReference={formData.locationReference}
        selectedCharacter={formData.selectedCharacter}
        locationMap={formData.locationMap}
        outfitMap={formData.outfitMap}
        outfitsReference={formData.outfits_reference}
        outfits={formData.outfits}
        propMap={formData.propMap}
        propsReference={formData.props_reference || formData.propReference}
        onChange={newText =>
          updateShotDataRef.current(shot.id, 'initial_image_prompt', newText)
        }
      />

      <div className="card-actions" style={{ justifyContent: 'space-between' }}>
        <Dropdown
          overlay={
            <Menu>
              <Menu.Item
                key="regenerate-image"
                onClick={() => handleRegenerateImage(sceneId, shot.id)}
                disabled={shot.isGenerating}
              >
                <Icon type="reload" /> Regenerate Image
              </Menu.Item>
              {/* <Menu.Item
                key="regenerate-with-reference"
                onClick={() => handleRegenerateWithReference(sceneId, shot.id)}
                disabled={shot.isGenerating}
              >
                <Icon type="file-image" /> Edit Image (Single Reference)
              </Menu.Item> */}

              <Menu.Item
                key="regenerate-with-reference-nano-banana"
                onClick={() =>
                  handleRegenerateWithReferenceNanoBanana(sceneId, shot.id)
                }
                disabled={shot.isGenerating}
              >
                <Icon type="file-image" /> Edit Image (Multiple References)
              </Menu.Item>
            </Menu>
          }
          trigger={['click']}
          placement="bottomLeft"
        >
          <Button
            size="small"
            icon="reload"
            disabled={shot.isGenerating}
            style={{ minWidth: 0, overflow: 'hidden' }}
          >
            <span
              style={{
                marginLeft: 4,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
              }}
            >
              Regenerate
            </span>
            <Icon type="down" style={{ fontSize: 10, marginLeft: 4 }} />
          </Button>
        </Dropdown>

        <Button
          size="small"
          icon="setting"
          onClick={() => handleEditSettings(sceneId, shot.id)}
          disabled={shot.isGenerating}
          style={{ minWidth: 0, overflow: 'hidden' }}
        >
          <span
            style={{
              marginLeft: 4,
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis'
            }}
          >
            Shot Editor
          </span>
        </Button>
      </div>

      <ImageHistoryModal
        visible={historyModalVisible}
        history={shot.images_history || []}
        onCancel={() => setHistoryModalVisible(false)}
        onSelect={url => {
          updateShotDataRef.current(shot.id, 'imageSrc', url)
          setHistoryModalVisible(false)
        }}
      />
    </div>
  )
}

export default ShotCard
